export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25735 3.28655L10.0117 3.28655V2.5848C10.0117 2.23392 10.2457 2 10.5965 2L13.4035 2C13.7544 2 13.9883 2.23392 13.9883 2.5848V3.28655L15.6258 3.28655C16.7954 3.28655 17.731 4.10526 17.731 5.27485L17.731 19.8947C17.731 21.0643 16.7954 22 15.6258 22H8.25735C7.20472 22 6.26904 21.0643 6.26904 19.8947L6.26904 5.27485C6.26904 4.10526 7.20472 3.28655 8.25735 3.28655ZM15.6258 4.69006L8.25735 4.69006C8.02343 4.69006 7.67255 4.92398 7.67255 5.27485L7.67255 19.8947C7.67255 20.2456 8.02343 20.4795 8.25735 20.4795H15.6258C15.9766 20.4795 16.2106 20.2456 16.2106 19.8947L16.2106 5.27485C16.2106 4.92398 15.9766 4.69006 15.6258 4.69006Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6257 9.13965C15.178 9.13965 15.6257 9.58736 15.6257 10.1396L15.6257 18.895C15.6257 19.4472 15.178 19.895 14.6257 19.895H9.25732C8.70504 19.895 8.25732 19.4472 8.25732 18.895L8.25732 10.1396C8.25732 9.58736 8.70504 9.13965 9.25732 9.13965L14.6257 9.13965Z"
      fill="currentColor"
    />
  </svg>
);
